import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getConsent, setConsent, onConsentChange, isTrackedPath, loadGoogleTag, trackPageView, installIntentTracking } from '../lib/analytics';

export const openCookieSettings = () => window.dispatchEvent(new Event('mv-open-cookie-settings'));

export const AnalyticsManager = () => {
  const { pathname } = useLocation();
  useEffect(() => installIntentTracking(), []);
  useEffect(() => {
    if (!isTrackedPath(pathname)) return;
    loadGoogleTag();
    trackPageView();
  }, [pathname]);
  return null;
};

export const CookieBanner = () => {
  const { pathname } = useLocation();
  const [consent, setC] = useState(getConsent);
  const [forced, setForced] = useState(false);
  useEffect(() => onConsentChange(setC), []);
  useEffect(() => {
    const open = () => setForced(true);
    window.addEventListener('mv-open-cookie-settings', open);
    return () => window.removeEventListener('mv-open-cookie-settings', open);
  }, []);
  if (!isTrackedPath(pathname) || (consent && !forced)) return null;
  const choose = (v) => { setConsent(v); setForced(false); };
  return (
    <div role="dialog" aria-live="polite" aria-label="Cookie choices" className="fixed inset-x-0 bottom-14 sm:bottom-0 z-[60] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="mx-auto max-w-3xl rounded-xl bg-white border border-slate-200 shadow-2xl p-4 sm:p-5 text-[color:var(--mv-navy)]">
        <p className="text-sm font-bold">Can we use advertising cookies?</p>
        <p className="mt-1 text-sm text-slate-600">
          We'd like to use Google Ads cookies to see which adverts lead to quote requests. They're off unless you say yes. We never share your name, phone, email or address with Google.
          {' '}<Link to="/cookies" className="underline font-semibold" data-testid="cookie-banner-policy">Cookie policy</Link>
        </p>
        {consent && <p className="mt-1 text-xs text-slate-500" data-testid="cookie-banner-current">Current choice: {consent.ads ? 'accepted' : 'rejected'}</p>}
        <div className="mt-3 grid grid-cols-2 gap-2 sm:flex sm:justify-end">
          <button type="button" onClick={() => choose(false)} className="h-11 px-5 rounded-md border-2 border-[color:var(--mv-navy)] text-[color:var(--mv-navy)] font-bold text-sm" data-testid="cookie-reject">Reject</button>
          <button type="button" onClick={() => choose(true)} className="h-11 px-5 rounded-md border-2 border-[color:var(--mv-navy)] bg-[color:var(--mv-navy)] text-white font-bold text-sm" data-testid="cookie-accept">Accept</button>
        </div>
      </div>
    </div>
  );
};
